// src/pages/NhlGames.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE } from "../api";

export default function NhlGames() {
  const [games, setGames] = useState([]);
  const [daysAhead, setDaysAhead] = useState(7);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fetchGames = async () => {
    setLoading(true);
    setError("");
    try {
      const all = [];
      const today = new Date();
      for (let i = 0; i < daysAhead; i++) {
        const d = new Date(today);
        d.setDate(d.getDate() + i);
        const day = d.toISOString().slice(0, 10);
        const url = `${API_BASE}/api/public/fixtures/daily?day=${day}&sport=nhl`;
        const r = await fetch(url, { cache: "no-store" });
        if (!r.ok) continue; // skip days with no data
        const data = await r.json();
        if (data.fixtures) all.push(...data.fixtures);
      }
      setGames(all);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [daysAhead]);

  const timeUTC = (iso) => {
    if (!iso) return "—";
    // already has Z or ±HH:MM offset → leave alone; otherwise append Z
    const s = /Z$|[+-]\d{2}:\d{2}$/.test(iso) ? iso : iso + "Z";
    try {
      const d = new Date(s);
      if (isNaN(d.getTime())) return iso.slice(11, 16);
      return d.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC",
      });
    } catch {
      return iso.slice(11, 16);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>NHL — Upcoming</h2>

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
        <span>Show next</span>
        <input
          type="number"
          min={1}
          max={30}
          value={daysAhead}
          onChange={(e) => setDaysAhead(parseInt(e.target.value || "7", 10))}
          style={{ width: 60 }}
        />
        <span>days</span>
        <button onClick={fetchGames}>Refresh</button>
      </div>

      {error && <p style={{ color: "#c00" }}>{error}</p>}

      {loading ? (
        <p>Loading...</p>
      ) : games.length === 0 ? (
        <p>No NHL games found in the selected window.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th align="left">Time (UTC)</th>
              <th align="left">Matchup</th>
              <th align="left">Competition</th>
              <th align="right">Best Home</th>
              <th align="right">Best Away</th>
            </tr>
          </thead>
          <tbody>
            {games.map((g) => (
              <tr
                key={g.id}
                onClick={() => navigate(`/nhl/game/${g.id}`)}
                style={{ cursor: "pointer", borderBottom: "1px solid #ddd" }}
              >
                <td>{timeUTC(g.kickoff_utc)}</td>
                <td>
                  <Link to={`/nhl/game/${g.id}`} onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", alignItems: "center", gap: 6, textDecoration: "none", color: "inherit" }}>
                    {g.home_logo && <img src={g.home_logo} alt={g.home_team} width={22} height={22} style={{ objectFit: "contain" }} onError={(e) => { e.currentTarget.style.display = "none"; }} />}
                    <strong>{g.home_team}</strong>
                    <span style={{ opacity: 0.5 }}>vs</span>
                    {g.away_logo && <img src={g.away_logo} alt={g.away_team} width={22} height={22} style={{ objectFit: "contain" }} onError={(e) => { e.currentTarget.style.display = "none"; }} />}
                    {g.away_team}
                  </Link>
                </td>
                <td>{g.comp || "NHL"}</td>
                <td align="right">
                  {g.best_home ? `${g.best_home.price} (${g.best_home.bookmaker})` : "—"}
                </td>
                <td align="right">
                  {g.best_away ? `${g.best_away.price} (${g.best_away.bookmaker})` : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
